<template>
    <l-layout :layout="['xs12']">
      <v-form ref="serviceForm">
        <v-card class="pa-3">
          <v-layout column>
            <v-layout>
              <v-flex xs6>
                <v-text-field label="服务名称" v-model="form.name" prepend-icon="$vuetify.icons.title" :rules="[$rules.requiredS()]"
                :disabled="disabledFlag"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-textarea label="服务描述" prepend-icon="$vuetify.icons.comment" v-model="form.description" rows="1" auto-grow
              :disabled="disabledFlag"></v-textarea>
            </v-layout>
            <v-layout justify-center>
              <v-btn flat color="primary" @click="addServiceMethod" :disabled="disabledFlag">添加服务方法</v-btn>
            </v-layout>
            <v-layout column  justify-center>
              <v-card v-for="(m,i) in form.service" class="pa-3 mb-2" :key="i">
                <v-layout column>
                  <v-layout>
                    <v-flex xs4>
                      <v-text-field label="方法名称" v-model="m.name" prepend-icon="$vuetify.icons.title" :rules="[$rules.requiredS()]"
                                    :disabled="disabledFlag"></v-text-field>
                    </v-flex>
                    <v-flex xs7>
                      <v-text-field label="回调地址" v-model="m.callBackUrl" prepend-icon="$vuetify.icons.code" :rules="[$rules.requiredS()]"
                                    :disabled="disabledFlag"></v-text-field>
                    </v-flex>
                    <v-flex xs1>
                      <v-btn flat color="error" @click="deleteServiceMethod(i)">删除</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-textarea label="方法描述" prepend-icon="$vuetify.icons.comment" v-model="m.description" rows="1" auto-grow
                                :disabled="disabledFlag"></v-textarea>
                  </v-layout>
                </v-layout>
              </v-card>
            </v-layout>
            <v-layout justify-center>
              <v-btn class="primary" @click="submit" :loading="loading" :disabled="disabledFlag">提交</v-btn>
            </v-layout>
          </v-layout>
        </v-card>
      </v-form>
    </l-layout>
</template>

<script>
    export default {
        name: "newIotService",
      data(){
          return {
            form:{
              name:'',
              description:"",
              institutionId:"",
              accessProtocol:"websocket",
              pduType:"RPC2.0",
              service:[]
            },
            disabledFlag:false,
            loading:false
          }
      },
      methods:{
        addServiceMethod(){
          this.form.service.push({
            method:"",
            description:"",
            callBackUrl:""
          })
        },
        deleteServiceMethod(index){
          this.form.service.splice(index,1)
        },
        async submit(){
          if(this.$refs.serviceForm.validate()){
            let methodList = []
            for(let i=0;i<this.form.service.length;i++){
              let m = this.form.service[i]
              methodList.push(	{
                "method":m.name,
                "description":m.description,
                "callBackUrl":m.callBackUrl
              })
            }
            let params = {
              "name":this.form.name,
              "description":this.form.description,
              "institutionId":this.$store.getters['login/institution'].id,
              "accessProtocol":"websocket",
              "pduType":"RPC2.0",
              "service":methodList
            }
            this.loading = true
            try {
              let res = await this.$store.dispatch('iot/addService',params)
              console.log(res)
              if(res.data.status+'' === '200'){
                this.$L.alert('success',{message:'注册成功'})
                this.disabledFlag = true
              }else{
                this.$L.alert('error',{message:'注册失败，原因：'+res.data.msg})
              }
            }catch (e) {
              console.log(e)
            }finally {
              this.loading = false
            }
          }else{
            this.$L.alert('error',{message:'表单数据不合法'})
          }
        }
      }
    }
</script>

<style scoped>

</style>
